<template>
  <div class="contest-container">
    <div class="row">
      <div class="col-12">
        <h2 class="text-center">{{ contest?.contestName }} Satış Tahmin Yarışması</h2>
        <p class="text-center text-muted">
            {{ contest?.contestDescription }}
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="timeline-container">
          <!-- Başlangıç ve Bitiş Değerleri -->
          <div class="timeline-labels">
            <div class="start-label">
              <strong>{{ contest?.minValue || 0 }}</strong>
              <small class="d-block text-muted">Başlangıç</small>
            </div>
            <div class="end-label">
              <strong>{{ contest?.maxValue || 2000 }}</strong>
              <small class="d-block text-muted">Bitiş</small>
            </div>
          </div>

          <!-- Horizontal Çizgi ve Tahminler -->
          <div class="timeline-wrapper">
            <div class="timeline-line"></div>
            
            <!-- Gerçek Satış Göstergesi -->
            <div 
              class="current-sales-indicator"
              :style="{ left: currentSalesPosition + '%' }"
            >
              <div class="indicator-line"></div>
              <div class="indicator-label">
                <strong>Gerçek: {{ currentSales }}</strong>
              </div>
            </div>

            <!-- Tahmin Yapanlar -->
            <div
              v-for="(participant, index) in sortedParticipants"
              :key="participant.id"
              class="participant-marker"
              :style="{ 
                left: participant.position + '%'
              }"
              :class="{
                'winner': participant.isWinner && !participant.isEliminated,
                'eliminated': participant.isEliminated,
                'position-top': participant.isTop,
                'position-bottom': !participant.isTop
              }"
            >
              <div 
                class="participant-image-wrapper"
                :style="{ 
                  transform: participant.verticalOffset !== 0 ? `translateY(${participant.verticalOffset}px)` : 'none',
                  zIndex: 10 + participant.level
                }"
              >
                <div 
                  v-if="participant.isTop"
                  class="participant-info"
                >
                  <div class="participant-name">{{ participant.participantName }}</div>
                  <div class="participant-guess">{{ participant.participantGuess }} adet</div>
                </div>
                <img 
                  :src="participant.photoUrl" 
                  :alt="participant.participantName"
                  class="participant-image"
                  @error="handleImageError"
                />
                <div 
                  v-if="!participant.isTop"
                  class="participant-info"
                >
                  <div class="participant-name">{{ participant.participantName }}</div>
                  <div class="participant-guess">{{ participant.participantGuess }} adet</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- İstatistikler -->
    <div class="row contest-stats">
      <div class="col-md-4">
        <div class="stat-card">
          <h5>Gerçek Satış</h5>
          <h3 class="text-primary">{{ currentSales }}</h3>
        </div>
      </div>
      <div class="col-md-4">
        <div class="stat-card">
          <h5>Kazanan</h5>
          <h3 class="text-success">{{ winnerName || '-' }}</h3>
        </div>
      </div>
      <div class="col-md-4">
        <div class="stat-card">
          <h5>Aktif Yarışmacı</h5>
          <h3 class="text-info">{{ activeParticipantsCount }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contest',
  data() {
    return {
      contest: null,
      currentSales: 1200,
      participants: [],
    //   participants: [
    //     {
    //       id: 1,
    //       name: 'Yasin Çakır',
    //       guess: 1238,
    //       photoUrl: '',
    //       isEliminated: false,
    //       isWinner: false,
    //     },
    //     {
    //       id: 2,
    //       name: 'Orhan Özdemir',
    //       guess: 828,
    //       photoUrl: '',
    //       isEliminated: false,
    //       isWinner: false,
    //     },
    //     {
    //       id: 3,
    //       name: 'Demet Çakır',
    //       guess: 700,
    //       photoUrl: '',
    //       isEliminated: false,
    //       isWinner: false,
    //     },
    //     {
    //       id: 4,
    //       name: 'Mert Gökbük',
    //       guess: 1000,
    //       photoUrl: '',
    //       isEliminated: false,
    //       isWinner: false,
    //     },
    //     {
    //       id: 5,
    //       name: 'Beytullah Narmanoğlu',
    //       guess: 1404,
    //       photoUrl: '',
    //       isEliminated: false,
    //       isWinner: false,
    //     },
    //     {
    //       id: 6,
    //       name: 'Özlem Çakar Çay',
    //       guess: 1888,
    //       photoUrl: '',
    //       isEliminated: false,
    //       isWinner: false,
    //     },
    //     {
    //       id: 7,
    //       name: 'Hayrettin Eygi',
    //       guess: 1573,
    //       photoUrl: '',
    //       isEliminated: false,
    //       isWinner: false,
    //     },
    //     {
    //       id: 8,
    //       name: 'Okan Gürses',
    //       guess: 1501,
    //       photoUrl: '',
    //       isEliminated: false,
    //       isWinner: false,
    //     },
    //     {
    //       id: 9,
    //       name: 'Can Çağlak',
    //       guess: 1500,
    //       photoUrl: '',
    //       isEliminated: false,
    //       isWinner: false,
    //     },
    //     {
    //       id: 10,
    //       name: 'Manolya Uzun',
    //       guess: 1454,
    //       photoUrl: '',
    //       isEliminated: false,
    //       isWinner: false,
    //     },
    //     {
    //       id: 11,
    //       name: 'Mustafa Aygün',
    //       guess: 950,
    //       photoUrl: '',
    //       isEliminated: false,
    //       isWinner: false,
    //     },
    //          ],
      // Beyaz yazı için okunabilir ve birbirinden ayırt edilebilir 15 renk paleti
      // Her renk ailesinden en ayırt edilebilir renkler seçildi
      colorPalette: [
        'E74C3C', // Kırmızı
        'E67E22', // Turuncu
        'F39C12', // Altın sarısı
        '27AE60', // Emerald yeşil
        '4CAF50', // Yeşil
        '16A085', // Teal
        '3498DB', // Parlak mavi
        '2980B9', // Koyu mavi
        '3F51B5', // İndigo mavi
        '8E44AD', // Mor
        '9C27B0', // Violet mor
        'E91E63', // Pembe
        '795548', // Kahverengi
        '607D8B', // Gri-mavi
        '2C3E50', // Koyu gri-mavi
      ],

      updateInterval: null,
      fetchInterval: null,
    };
  },
  computed: {
    minValue() {
      return this.contest?.minValue || 0;
    },
    maxValue() {
      return this.contest?.maxValue || 2000;
    },
    sortedParticipants() {
      const range = this.maxValue - this.minValue;
      const MIN_DISTANCE_PERCENT = 2.5; // Minimum %2.5 mesafe (yaklaşık 50px ekranda)
      
      const participants = [...this.participants]
        .sort((a, b) => a.participantGuess - b.participantGuess)
        .map((participant, index) => ({
          ...participant,
          position: range > 0 ? ((participant.participantGuess - this.minValue) / range) * 100 : 0,
        }));
      
      // Çakışma tespiti ve dikey yerleştirme
      // Önce tüm çakışan participantları grupla
      const groups = [];
      const participantToGroup = new Map();
      
      participants.forEach((participant, i) => {
        // Bu participant'ın hangi gruba ait olduğunu bul
        let assignedGroup = null;
        
        // Mevcut gruplarla kontrol et
        for (let j = 0; j < groups.length; j++) {
          const group = groups[j];
          // Grubun herhangi bir participant'ı ile çakışma var mı?
          for (const groupParticipant of group.participants) {
            const distance = Math.abs(participant.position - groupParticipant.position);
            if (distance < MIN_DISTANCE_PERCENT) {
              assignedGroup = group;
              break;
            }
          }
          if (assignedGroup) break;
        }
        
        if (assignedGroup) {
          // Mevcut gruba ekle
          assignedGroup.participants.push(participant);
          participantToGroup.set(i, assignedGroup);
        } else {
          // Yeni grup oluştur
          const newGroup = {
            participants: [participant],
          };
          groups.push(newGroup);
          participantToGroup.set(i, newGroup);
        }
      });
      
      // Her participant için dikey offset hesapla
      const adjustedParticipants = participants.map((participant, index) => {
        const group = participantToGroup.get(index);
        // Participant'ın grup içindeki pozisyonunu bul (pozisyon değerine göre)
        const sortedGroupParticipants = [...group.participants].sort((a, b) => a.position - b.position);
        const positionInGroup = sortedGroupParticipants.findIndex(p => 
          Math.abs(p.position - participant.position) < 0.01
        );
        const groupSize = group.participants.length;
        
        let verticalOffset = 0;
        let isTop = false;
        let level = positionInGroup;
        
        if (groupSize === 1) {
          // Tek başına, basit üst/alt
          isTop = index % 2 === 0;
        } else {
          // Grup içinde
          if (level === 0) {
            // İlk participant merkezde
            verticalOffset = 0;
            isTop = index % 2 === 0;
          } else if (level === 1) {
            // İkinci participant üstte
            verticalOffset = -80;
            isTop = true;
          } else if (level === 2) {
            // Üçüncü participant altta
            verticalOffset = 80;
            isTop = false;
          } else if (level === 3) {
            // Dördüncü participant daha üstte
            verticalOffset = -140;
            isTop = true;
          } else if (level === 4) {
            // Beşinci participant daha altta
            verticalOffset = 140;
            isTop = false;
          } else {
            // Daha fazla çakışma varsa devam et
            if (level % 2 === 1) {
              const upLevel = Math.floor((level + 1) / 2);
              verticalOffset = -80 - (upLevel - 1) * 60;
              isTop = true;
            } else {
              const downLevel = level / 2;
              verticalOffset = 80 + (downLevel - 1) * 60;
              isTop = false;
            }
          }
        }
        
        return {
          ...participant,
          verticalOffset,
          isTop,
          level,
        };
      });
      
      return adjustedParticipants;
    },
    currentSalesPosition() {
      const range = this.maxValue - this.minValue;
      if (range === 0) return 0;
      return ((this.currentSales - this.minValue) / range) * 100;
    },
      winnerName() {
        const winner = this.participants.find((p) => p.isWinner && !p.isEliminated);
        return winner ? winner.participantName : null;
      },
    activeParticipantsCount() {
      return this.participants.filter((p) => !p.isEliminated).length;
    },
  },
  mounted() {
    // İlk veriyi yükle
    this.fetchSalesData();
    
    // Contest aktif ise her 15 saniyede bir veriyi güncelle
    this.startAutoFetch();
  },
  beforeUnmount() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
    if (this.fetchInterval) {
      clearInterval(this.fetchInterval);
    }
  },
  methods: {
    startSimulation() {
      // Simülasyon: Her 3 saniyede bir satış verisi güncelleniyor
      this.updateInterval = setInterval(() => {
        // Gerçek uygulamada API'den gelecek
        const increment = Math.floor(Math.random() * 50) + 10;
        this.currentSales = Math.min(this.currentSales + increment, this.maxValue);
        
        // Kazanan ve kaybedenleri güncelle
        this.updateWinnersAndLosers();
      }, 3000);
    },
    updateWinnersAndLosers() {
      // Gerçek satış değerine en yakın tahmini bul (büyük veya küçük fark etmez)
      let closestParticipant = null;
      let minDifference = Infinity;

      // Tüm aktif participantlar arasında en yakın olanı bul
      this.participants.forEach((participant) => {
        if (participant.isEliminated) return;
        
        const difference = Math.abs(participant.participantGuess - this.currentSales);
        
        if (difference < minDifference) {
          minDifference = difference;
          closestParticipant = participant;
        }
      });

      // Tüm kazanan işaretlerini sıfırla
      this.participants.forEach((p) => {
        p.isWinner = false;
        // Eleme mantığını kaldırdık, artık kimse elenmiyor
        // p.isEliminated = false; // Eğer eleme sistemi tamamen kaldırılacaksa
      });

      // En yakın tahmini kazanan yap
      if (closestParticipant && !closestParticipant.isEliminated) {
        closestParticipant.isWinner = true;
      }
    },
    handleImageError(event) {
      // Resim yüklenemezse placeholder göster
    //   event.target.src = 'https://placehold.co/80/CCCCCC/FFFFFF?text=NO+IMG';
    },
    startAutoFetch() {
      // Eğer interval zaten varsa temizle
      if (this.fetchInterval) {
        clearInterval(this.fetchInterval);
        this.fetchInterval = null;
      }
      
      // Contest aktif ise interval başlat
      if (this.contest?.active) {
        this.fetchInterval = setInterval(() => {
          this.fetchSalesData();
        }, 15000);
      }
    },
    async fetchSalesData() {
      // Gerçek API çağrısı
      try {
        const response = await this.axios.get(`${this.baseUrl}/contest/${this.$route.params.id}`);
        this.contest = response.data.contest;
        this.currentSales = response.data.currentValue;
        this.participants = response.data.participants;
        this.assignPhotoUrls();
        this.updateWinnersAndLosers();
        
        // Contest durumuna göre auto-fetch'i güncelle
        this.startAutoFetch();
      } catch (error) {
        console.error('Satış verisi alınamadı:', error);
      }
    },
    generateRandomColor() {
      // 30 renk paletinden rastgele bir renk seç
      const randomIndex = Math.floor(Math.random() * this.colorPalette.length);
      return this.colorPalette[randomIndex];
    },
    getInitials(name) {
      return name.split(' ').map(word => word.charAt(0).toUpperCase()).join('').slice(0, 2);
    },
    assignPhotoUrls() {
      // Kullanılabilir renkleri kopyala
      const availableColors = [...this.colorPalette];
      
      // Her yarışmacıya farklı bir renk ata
      for (const participant of this.participants) {
        if (availableColors.length === 0) {
          // Eğer tüm renkler kullanıldıysa, baştan başla
          availableColors.push(...this.colorPalette);
        }
        
        // Rastgele bir renk seç ve listeden çıkar
        const randomIndex = Math.floor(Math.random() * availableColors.length);
        const selectedColor = availableColors.splice(randomIndex, 1)[0];
        
        participant.photoUrl = `https://placehold.co/80/${selectedColor}/FFFFFF?text=${this.getInitials(participant.participantName)}`;
      }
    },
  },
};
</script>

<style scoped>
.contest-container {
  max-width: 1400px;
  margin: 0 auto;
  min-height: calc(100vh - 100px);
  padding-bottom: 40px;
}

.timeline-container {
  position: relative;
  margin: 30px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.timeline-labels {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  padding: 0 20px;
}

.start-label,
.end-label {
  text-align: center;
  background: white;
  padding: 10px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.start-label strong,
.end-label strong {
  font-size: 24px;
  color: #2c3e50;
}

.timeline-wrapper {
  position: relative;
  height: 320px;
  margin: 0 20px;
}

.timeline-line {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(to right, #e0e0e0 0%, #2196F3 50%, #e0e0e0 100%);
  border-radius: 2px;
  transform: translateY(-50%);
}

.current-sales-indicator {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  transition: left 0.5s ease;
}

.indicator-line {
  width: 3px;
  height: 30px;
  background: #FF5722;
  margin: 0 auto;
  border-radius: 2px;
  box-shadow: 0 2px 5px rgba(255, 87, 34, 0.5);
}

.indicator-label {
  margin-top: 5px;
  padding: 5px 10px;
  background: #FF5722;
  color: white;
  border-radius: 5px;
  font-size: 14px;
  white-space: nowrap;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.participant-marker {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  transition: all 0.3s ease;
  pointer-events: none;
}

.participant-marker.position-top {
  transform: translate(-50%, calc(-50% - 80px));
}

.participant-marker.position-bottom {
  transform: translate(-50%, calc(-50% + 80px));
}

.participant-image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s ease;
  pointer-events: none;
}

.participant-image-wrapper * {
  pointer-events: auto;
}

.participant-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 4px solid #2196F3;
  object-fit: cover;
  background: white;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
  pointer-events: auto;
}

.participant-marker.winner .participant-image {
  border-color: #4CAF50;
  box-shadow: 0 0 20px rgba(76, 175, 80, 0.6);
  animation: pulse-green 2s infinite;
}

.participant-marker.eliminated .participant-image {
  border-color: #F44336;
  opacity: 0.6;
  filter: grayscale(100%);
}

.participant-info {
  text-align: center;
  background: white;
  padding: 8px 12px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 120px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  position: relative;
  z-index: 100;
  pointer-events: none;
}

/* Sadece img'ye hover olduğunda bilgi görünsün */
/* Modern tarayıcılar için:has() selector */
.participant-image-wrapper:has(.participant-image:hover) .participant-info {
  opacity: 1;
  visibility: visible;
}

/* Eski tarayıcı desteği için fallback - img'den sonraki sibling */
.participant-image:hover ~ .participant-info {
  opacity: 1;
  visibility: visible;
}

.participant-marker.position-top .participant-info {
  margin-bottom: 8px;
}

.participant-marker.position-bottom .participant-info {
  margin-top: 8px;
}

.participant-name {
  font-weight: bold;
  font-size: 14px;
  color: #2c3e50;
  margin-bottom: 4px;
}

.participant-guess {
  font-size: 12px;
  color: #666;
  font-weight: 600;
}

.stat-card {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  height: 100%;
}

.stat-card h5 {
  color: #666;
  font-size: 14px;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.stat-card h3 {
  font-size: 32px;
  margin: 0;
  font-weight: bold;
}

@keyframes pulse-green {
  0%, 100% {
    box-shadow: 0 0 20px rgba(76, 175, 80, 0.6);
  }
  50% {
    box-shadow: 0 0 30px rgba(76, 175, 80, 0.9);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .participant-image {
    width: 60px;
    height: 60px;
  }
  
  .participant-info {
    min-width: 100px;
    padding: 6px 10px;
  }
  
  .participant-name {
    font-size: 12px;
  }
  
  .participant-guess {
    font-size: 11px;
  }
  
  .timeline-wrapper {
    height: 180px;
  }
  
  .participant-marker.position-top {
    transform: translate(-50%, calc(-50% - 60px));
  }

  .participant-marker.position-bottom {
    transform: translate(-50%, calc(-50% + 60px));
  }
}
</style>